import React, { Component } from 'react';

import { FormGroup, UncontrolledTooltip } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

import AddAppAlert from '../alert/AddAppAlert';
import Loader from '../loader/Loader';
import MagazineCreateButton from '../formFields/MagazineCreateButton';
import AutoLocaleCheckbox from '../formFields/AutoLocaleCheckbox';
import renderSelectField from '../formFields/Select';
import TagsImageRadio from '../formFields/TagsImageRadio';
import { validate } from '../../utils/form';

class PickedMagazineForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country: '',
      languages: [],
      tags: []
    };

    this.onAppChange = this.onAppChange.bind(this);
    this.onCountryChange = this.onCountryChange.bind(this);
    this.onLanguageChange = this.onLanguageChange.bind(this);
  }

  componentDidMount() {
    const { appsLoading, fetchAllApps } = this.props;
    if (appsLoading) {
      fetchAllApps();
    }
  }

  componentDidUpdate() {
    let { country } = this.state;
    const {
      data: { countries = [], UnitedState },
      changeFieldValue,
      formValues = {}
    } = this.props;
    if (!country && countries.length > 0 && formValues.app) {
      let country = UnitedState || countries[0];
      changeFieldValue('country', country);
      this.onCountryChange(country);
    } else if (country && countries.length === 0) {
      changeFieldValue('country', null);
      this.onCountryChange({});
    }
  }

  onAppChange(selectedApp) {
    this.props.fetchTagsData(selectedApp.value);
  }

  onCountryChange({ value }) {
    const {
      data: { languages = {}, keywordsData = {} },
      changeFieldValue,
      resetURL
    } = this.props;
    let language;

    const languageValues = languages[value] || [];

    /* for (let languageValue of languageValues) {
      if (languageValue.value === 'en') {
        language = languageValue;
      }
    }*/
    language = languageValues[0] || null;
    this.setState(() => ({
      languages: languageValues,
      country: value,
      tags:
        keywordsData[value] && language
          ? keywordsData[value][language.value]
          : []
    }));
    changeFieldValue('language', language);
    changeFieldValue('tag', null);
    resetURL();
  }

  onLanguageChange({ value }) {
    const {
      data: { keywordsData = {} },
      changeFieldValue,
      resetURL
    } = this.props;
    const { country } = this.state;

    this.setState(() => ({
      tags: keywordsData[country] ? keywordsData[country][value] : []
    }));
    changeFieldValue('tag', null);
    resetURL();
  }

  render() {
    const {
      appsLoading,
      apps,
      loading,
      url,
      data: { countries },
      handleSubmit,
      generating,
      formValues = {}
    } = this.props;
    const { languages, tags, country } = this.state;
    const hasNoApps = !appsLoading && apps.length === 0;
    const isAppNotSelected = !formValues.app;
    const isAutoLocale = !!formValues.autoLocale;

    return (
      <Loader loaded={appsLoading}>
        {hasNoApps && <AddAppAlert />}
        <div className="content-container">
          <div className="page-header">
            <div className="page-title">Add our editor picked magazine</div>
            <div id="what-is">What are Editor picks magazines?</div>
            <UncontrolledTooltip
              placement="bottom"
              target="what-is"
              className="what-is-tooltip"
            >
              These choices represent our best content, divided to our most
              popular content categories. These lists are automatically tweaked
              and improved over time by our editorial team.
            </UncontrolledTooltip>
          </div>
          <form className="form form--create-magazine" onSubmit={handleSubmit}>
            <ol>
              <li>
                <div className="form__form-group select-app">
                  <span className="form__form-group-label">Select an App:</span>
                  <Field
                    name="app"
                    component={renderSelectField}
                    placeholder="Select App"
                    onChange={this.onAppChange}
                    options={apps.map(app => ({ label: app.name, value: app }))}
                    isDisabled={hasNoApps}
                    className="form__form-group-select"
                  />
                </div>
              </li>
              <li>
                <div className="form__form-group select-country-auto">
                  <div className="form__form-group-label">
                    Select country and Language:
                  </div>
                  <div>
                    <AutoLocaleCheckbox />
                  </div>
                </div>
                <div className="form__form-group select-country-manually">
                  <Field
                    name="country"
                    placeholder="Select Country"
                    component={renderSelectField}
                    onChange={this.onCountryChange}
                    options={countries}
                    label="Or manually select Country"
                    isDisabled={isAppNotSelected || isAutoLocale}
                    className="form__form-group-select"
                  />
                  <Field
                    name="language"
                    placeholder="Select Language"
                    component={renderSelectField}
                    onChange={this.onLanguageChange}
                    options={languages}
                    label="And Language"
                    isDisabled={isAppNotSelected || isAutoLocale}
                    className="form__form-group-select"
                  />
                </div>
              </li>
              <li>
                <FormGroup>
                  <div className="form__form-group-label">
                    Choose one of our editor's pick magazines:
                  </div>
                  <Loader loaded={loading}>
                    <TagsImageRadio
                      name="tag"
                      options={tags}
                      disabled={isAutoLocale}
                    />
                  </Loader>
                </FormGroup>
              </li>
              <li>
                <MagazineCreateButton
                  url={url}
                  disabled={
                    loading ||
                    isAppNotSelected ||
                    generating ||
                    (!isAutoLocale && !country)
                  }
                />
              </li>
            </ol>
          </form>
        </div>
      </Loader>
    );
  }
}

export default reduxForm({
  form: 'PickedMagazineForm',
  validate
})(PickedMagazineForm);



// WEBPACK FOOTER //
// ./src/components/pickedMagazine/PickedMagazineForm.js